/* eslint-disable import/no-deprecated */
import { Component, inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Amplify } from '@aws-amplify/core';
import { NbSidebarService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Subject, takeUntil } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { CONFIG, ENVIRONMENT } from '../environments/environment';
import { RouterState } from './features/auth/redux/router-state';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnDestroy {
  public isLoggedIn$: Observable<boolean> = inject(Store).select(RouterState.isLogedIn);
  private unsubscribe: Subject<void> = new Subject();

  public isLoggedIn = false;
  public compacted = false;
  public environment = ENVIRONMENT;

  constructor(private router: Router, public sidebarService: NbSidebarService) {
    Amplify.configure(CONFIG);
    this.sidebarService
      .onToggle()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => (this.compacted = !this.compacted));
    this.isLoggedIn$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.isLoggedIn = data));
    if (window.location.href.includes('callback')) {
      this.router.navigateByUrl('/redirect');
    } else if (window.location.href.includes('signout')) {
      this.router.navigateByUrl('/signout');
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
